import angular from 'angular';
import { RenderWithWrapper } from '../../../../../global/global.react';
import { AccessDropdown } from '../../../../../modules/teleconsent/components/access-dropdown';
class AccessLevelDropdownBridgeController {
    constructor($element) {
        this.$element = $element;
        this.render = () => {
            RenderWithWrapper(AccessDropdown, {
                accessLevel: this.accessLevel,
                handleChange: this.handleChange,
                document: this.document,
            }, this.$element[0]);
        };
    }
    $onInit() {
        this.render();
    }
}
const accessLevelDropdownBridge = {
    template: '<div></div>',
    bindings: {
        accessLevel: '<',
        document: '<',
        handleChange: '<',
    },
    controller: AccessLevelDropdownBridgeController,
};
export default angular
    .module('doxy.realtime.components.teleconsent.manager.accessLevelDropdownBridge', [])
    .component('accessLevelDropdownBridge', accessLevelDropdownBridge).name;
